/**
 * How long to disable buttons after sending a new OTP or verification code.
 */
export const SEND_TIMEOUT_MS = 15000
